// src/RouteTracker.tsx
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { initGA, trackPageview } from '../../utils/googleAnalytics'

export const RouteTracker = () => {
  const location = useLocation()

  useEffect(() => {
    initGA() // initialize GA once
  }, [])

  useEffect(() => {
    trackPageview(location.pathname + location.search)
  }, [location])

  return null
}
